import { BaseNode, BaseNodeProps } from "./BaseNode";
import TimerIcon from "lucide-react/dist/esm/icons/timer";
import CheckCircle2Icon from "lucide-react/dist/esm/icons/check-circle-2";
import Loader2Icon from "lucide-react/dist/esm/icons/loader-2";
import PauseCircleIcon from "lucide-react/dist/esm/icons/pause-circle";
import { cn } from "@quake/shared-ui/lib/utils";

type DelayNodeProps = BaseNodeProps & {
  readOnly: boolean;
  data: {
    label: string;
    readableId: string;
    duration?: number;
    unit?: "seconds" | "minutes" | "hours" | "days";
    until?: string;
    output?: any;
    isExecuting?: boolean;
    isPaused?: boolean;
    error?: any;
  };
  id: string;
};

export function DelayNode({
  data,
  onAddAction,
  onEdit,
  ...props
}: DelayNodeProps & { onAddAction?: ({ edgeColor }: { edgeColor?: string }) => void; onEdit?: () => void }) {
  return (
    <BaseNode
      className={cn(
        "text-foreground",
        data.isExecuting && "border-2 border-blue-400",
        data.isPaused && "border-2 border-amber-400",
        data.error && "border-2 border-red-500",
        data.output && !data.error && "border-2 border-green-500",
      )}
      color="bg-background border"
      data={{ ...data, label: data.label || "Delay" }}
      icon={<TimerIcon className="w-5 h-5 text-foreground" />}
      isSourceConnectable
      isTargetConnectable
      onAddAction={onAddAction}
      onEdit={onEdit}
      {...props}
    >
      {data.isExecuting && (
        <div className="absolute -top-2 -right-2 bg-blue-500 rounded-full p-1">
          <Loader2Icon className="w-4 h-4 motion-preset-spin" />
        </div>
      )}
      {data.isPaused && !data.isExecuting && (
        <div className="absolute -top-2 -right-2 bg-amber-500 rounded-full p-1 cursor-pointer" onClick={onEdit}>
          <PauseCircleIcon className="w-4 h-4" />
        </div>
      )}
      {data.output && !data.error && !data.isPaused && !data.isExecuting && (
        <div className="absolute -top-2 -right-2 bg-green-500 rounded-full p-1 cursor-pointer" onClick={onEdit}>
          <CheckCircle2Icon className="w-4 h-4" />
        </div>
      )}
    </BaseNode>
  );
}
